<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Dashboard</h3>
      </div>
      <div class="layout__controls">
        <div class="form-inline center-xs">
          <label for="general">
            <input value="G" v-model="form.filtro" type="radio" name="filtro" id="general" />
            <span>General</span>
          </label>
          <label for="especifico">
            <input value="R" v-model="form.filtro" type="radio" name="filtro" id="especifico" />
            <span>Por rango de fechas</span>
          </label>
          <div v-show="form.filtro === 'R'" class="form-field">
            <div class="datepicker-field">
              <VueCtkDateTimePicker
                id="desde"
                label="YYYY-MM-DD"
                v-model="form.desde"
                locale="es"
                no-label
                only-date
                button-now-translation="Ahora"
                format="YYYY-MM-DD"
                formatted="YYYY-MM-DD"
              />
              <span v-if="errores.desde" class="helper-text text-danger" slot="helper">
                <strong>{{ errores.desde[0] }}</strong>
              </span>
            </div>
          </div>
          <div v-show="form.filtro === 'R'" class="form-field">
            <div class="datepicker-field">
              <VueCtkDateTimePicker
                id="hasta"
                label="YYYY-MM-DD"
                v-model="form.hasta"
                locale="es"
                no-label
                only-date
                button-now-translation="Ahora"
                format="YYYY-MM-DD"
                formatted="YYYY-MM-DD"
              />
              <span v-if="errores.hasta" class="helper-text text-danger" slot="helper">
                <strong>{{ errores.hasta[0] }}</strong>
              </span>
            </div>
          </div>
          <button @click="consultar" class="btn-info" type="button">
            <i class="fa fa-search"></i>
            <span>Consultar</span>
          </button>
        </div>
      </div>
    </div>
    <div v-show="tipo === 'N'" class="row">
      <div class="col-xs-12">
        <div class="grid grid--fit">
          <button-card
            btn-color="btn-secondary"
            fa-name="fa-check"
            :counter="consultasExitosas"
          >Consultas exitosas</button-card>
          <button-card
            prefix="$ "
            btn-color="btn-info"
            fa-name="fa-money"
            :counter="ingresosPorConsultas"
          >Ingresos por consultas</button-card>
          <button-card
            btn-color="btn-success"
            prefix="$ "
            fa-name="fa-balance-scale"
            :counter="margenGanancias"
          >Margen de ganancias</button-card>
        </div>
      </div>
      <div class="col-xs-12">
        <div class="grid grid--fit">
          <button-card
            btn-color="btn-danger"
            prefix="$ "
            fa-name="fa-undo"
            :counter="devolucionesConsultas"
          >Devoluciones de consultas</button-card>
          <button-card
            btn-color="btn-primary"
            fa-name="fa-user-md"
            :counter="totalDoctores"
          >Médicos totales</button-card>
          <button-card
            btn-color="btn-dark"
            fa-name="fa-users"
            :counter="totalPacientes"
          >Pacientes totales</button-card>
        </div>
      </div>
    </div>
    <div v-show="tipo === 'N'" class="row mt-2">
      <div class="col-xs-12 col-md-4">
        <div class="card">
          <div class="card__title">
            <h5>Consultas</h5>
          </div>
          <div class="card__content">
            <pie-chart :data="consultasGenerales"></pie-chart>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="card">
          <div class="card__title">
            <h5>Top 10 de médicos</h5>
          </div>
          <div class="card__content">
            <bar-chart :data="doctoresTop"></bar-chart>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-4">
        <div class="card">
          <div class="card__title">
            <h5>Top 10 de pacientes</h5>
          </div>
          <div class="card__content">
            <bar-chart :data="pacientesTop"></bar-chart>
          </div>
        </div>
      </div>
    </div>
    <div v-show="tipo === 'N'" class="row mt-4">
      <div class="col-xs-12">
        <div class="grid grid--fit">
          <button-card
            prefix="$ "
            btn-color="btn-warning"
            fa-name="fa-minus-square"
            :counter="cuentasPagar"
          >Cuentas por pagar</button-card>
          <button-card
            prefix="$ "
            btn-color="btn-bus200"
            fa-name="fa-minus"
            :counter="totalPagadoDoctor"
          >Total pagado a médicos</button-card>
          <button-card
            btn-color="btn-bus300"
            prefix="$ "
            fa-name="fa-university"
            :counter="totalComisionBancos"
          >Total de comisiones de bancos</button-card>
        </div>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-xs-12">
        <div class="card">
          <div class="card__title">
            <h5>Consultas por médico {{ selectedDoctor !== null?'- ' + selectedDoctor.nombre_cabecera:'' }}</h5>
            <div v-show="doctores.length > 1" class="card__controls">
              <div class="form-field select2">
                <div class="select2-field select2-field--stretch">
                  <v-select
                    id="doctor"
                    @input="consultarDoctor"
                    placeholder="Seleccione un médico..."
                    :options="doctores"
                    label="nombre_cabecera"
                    v-model="selectedDoctor"
                  ></v-select>
                  <label for="doctor">Médico</label>
                  <span v-if="errores.doctor_id" class="helper-text text-danger" slot="helper">
                    <strong>{{ errores.doctor_id[0] }}</strong>
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div class="card__content">
            <div v-show="form.doctor_id !== ''" class="row">
              <div class="col-xs-12 col-md-4">
                <pie-chart :data="consultasDoctor"></pie-chart>
              </div>
              <div class="col-xs-12" :class="{
                'col-md-8': tipo === 'N',
                'col-md-4': tipo !== 'N'
              }">
                <div class="grid grid--fit">
                  <button-card
                    prefix="$ "
                    btn-color="btn-warning"
                    fa-name="fa-minus-square"
                    :counter="cuentasPagarDoctor"
                  >{{ tipo === 'N'?'Cuentas por pagar':'Cuentas por cobrar' }}</button-card>
                  <button-card
                    v-if="tipo === 'N'"
                    prefix="$ "
                    btn-color="btn-bus200"
                    fa-name="fa-minus"
                    :counter="totalPagadoDoctorDoctor"
                  >Total pagado</button-card>
                  <button-card
                    v-if="tipo === 'N'"
                    btn-color="btn-bus300"
                    prefix="$ "
                    fa-name="fa-university"
                    :counter="totalComisionBancosDoctor"
                  >Total de comisiones de bancos</button-card>
                  <button-card
                    v-if="tipo === 'N'"
                    btn-color="btn-success"
                    fa-name="fa-balance-scale"
                    prefix="$ "
                    :counter="margenGananciasDoctor"
                  >Margen de ganancias</button-card>
                </div>
              </div>
            </div>
            <div class="row" v-show="form.doctor_id === ''">
              <div class="col-xs-12">
                <p>Debe seleccionar un médico.</p>
              </div>
            </div>
          </div>
          
        </div>
      </div>
      
    </div>
    <div v-show="tipo === 'N'" class="row mt-4">
      <div class="col-xs-12 col-md-4">
        <div class="card">
     
          <div class="card__title">
            <h5>Tarjetas por consultas</h5>
              
          </div>
          <div class="card__content">
            <pie-chart :data="consultasTarjetasCredito"></pie-chart>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  props: {
    totalDoctores: {
      type: Number,
      required: false,
      default: 0
    },
    totalPacientes: {
      type: Number,
      required: false,
      default: 0
    },
    doctores: {
      type: Array,
      required: false,
      default: function() {
        return [];
      }
    },
    tipo: {
      type: String,
      required: false,
      default: "N"
    }
  },
  mounted: function() {},
  data: function() {
    return {
      selectedDoctor: null,
      form: {
        filtro: "G",
        desde: moment(new Date()).format("YYYY-MM-DD"),
        hasta: moment(new Date()).format("YYYY-MM-DD"),
        doctor_id: ""
      },
      formt: {
        filtrot:"G",
        desde: moment(new Date()).format("YYYY-MM-DD"),
        hasta: moment(new Date()).format("YYYY-MM-DD"),
      },
      errores: {},
      consultasExitosas: 0,
      margenGanancias: 0,
      ingresosPorConsultas: 0,
      devolucionesConsultas: 0,
      consultasGenerales: [
        ["Iniciadas", 0],
        ["Rechazadas", 0],
        ["Pendientes", 0],
        ["Finalizadas", 0]
      ],
      consultasTarjetasCredito:[
        ["Visa", 0],
        ["Mastercard", 0],
        ["American Express", 0],
        ["Diners", 0],
        ["Discover", 0],
        ["Maestro", 0],

      ],
      doctoresTop: [],
      pacientesTop: [],
      cuentasPagar: 0,
      totalPagadoDoctor: 0,
      totalComisionBancos: 0,
      consultasDoctor: [
        ["Iniciadas", 0],
        ["Rechazadas", 0],
        ["Pendientes", 0],
        ["Finalizadas", 0]
      ],
      cuentasPagarDoctor: 0,
      totalPagadoDoctorDoctor: 0,
      totalComisionBancosDoctor: 0,
      margenGananciasDoctor: 0
    };
  },
  methods: {
  
    consultar: function() {
      this.consultarDoctor();
      if (this.tipo === "N") {
        let that = this;
        axios
          .get(url + "/dashboard", {
            params: this.form
          })
          .then(function(response) {
            that.consultasGenerales = [
              ["Iniciadas", response.data.iniciadas],
              ["Rechazadas", response.data.rechazadas],
              ["Pendientes", response.data.pendientes],
              ["Finalizadas", response.data.exitosas]
            ];
            that.consultasTarjetasCredito = [
              ["Visa", response.data.visa],
              ["Mastercard", response.data.mastercard],
              ["American Express", response.data.americanexpress],
              ["Diners", response.data.diners],
              ["Discover", response.data.discover],
              ["Maestro", response.data.maestro],
            
            ];
            that.consultasExitosas = response.data.exitosas;
            that.ingresosPorConsultas = response.data.ingresos;
            that.margenGanancias = response.data.ganancias;
            that.devolucionesConsultas = response.data.devoluciones;
            that.totalComisionBancos = response.data.totalBancos;
            that.totalPagadoDoctor = response.data.totalDoctores;
            that.cuentasPagar = response.data.cuentasPorPagar;
            that.doctoresTop.splice(0, that.doctoresTop.length);
            for (let i = 0; i < response.data.doctores.length; i++) {
              that.doctoresTop.push([
                response.data.doctores[i].nombre_cabecera,
                response.data.doctores[i].consultas
              ]);
            }
            that.pacientesTop.splice(0, that.pacientesTop.length);
            for (let i = 0; i < response.data.pacientes.length; i++) {
              that.pacientesTop.push([
                response.data.pacientes[i].nombre_completo,
                response.data.pacientes[i].consultas
              ]);
            }
          })
          .catch(function(error) {
            if (error.response) {
              let response = error.response;
              if (response.status === 422) {
                that.errores = response.data.errors;
              } else
                swal("Hubo un error, intente nuevamente.", "Error", "error");
            }
          });
      }
    },
    consultarDoctor: function() {
      if (this.selectedDoctor !== null)
        this.form.doctor_id = this.selectedDoctor.id;
      else this.form.doctor_id = "";
      if (this.form.doctor_id !== "") {
        let that = this;
        axios
          .get(url + "/dashboard-doctor", {
            params: this.form
          })
          .then(function(response) {
            that.consultasDoctor = [
              ["Iniciadas", response.data.iniciadas],
              ["Rechazadas", response.data.rechazadas],
              ["Pendientes", response.data.pendientes],
              ["Finalizadas", response.data.finalizadas]
            ];
            that.totalPagadoDoctorDoctor = response.data.totalDoctores;
            that.margenGananciasDoctor = response.data.ganancias;
            that.totalComisionBancosDoctor = response.data.totalBancos;
            that.cuentasPagarDoctor = response.data.cuentasPorPagar;
          })
          .catch(function(error) {
            if (error.response) {
              let response = error.response;
              if (response.status === 422) {
                that.errores = response.data.errors;
              } else
                swal("Hubo un error, intente nuevamente.", "Error", "error");
            }
          });
      }
    }
  },
  mounted: function() {
    if (this.doctores.length > 0) {
      this.selectedDoctor = this.doctores[0];
      this.consultarDoctor();
    }
    if (this.tipo === "N") this.consultar();
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/KDashboard.vue